export default "__VITE_ASSET__b3574552__"